const WHATSAPP_NUMBER = "2347036858658";
const SUPPORT_MESSAGE = "Hi, I need support with MekEdge.";

function WhatsAppFloat() {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(SUPPORT_MESSAGE)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with support on WhatsApp"
      className="fixed right-4 bottom-6 z-[999] flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg transition-transform duration-200 hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#25D366]"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="h-6 w-6"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M12.04 2c-5.51 0-9.98 4.47-9.98 9.98 0 1.76.46 3.48 1.33 4.99L2 22l5.17-1.35c1.45.79 3.08 1.21 4.87 1.21h.01c5.51 0 9.98-4.47 9.98-9.98S17.55 2 12.04 2zm5.83 14.17c-.24.67-1.4 1.26-1.93 1.34-.49.07-1.11.1-1.8-.12-.42-.13-.96-.32-1.66-.62-2.92-1.26-4.82-4.2-4.97-4.4-.15-.2-1.19-1.58-1.19-3.01 0-1.42.75-2.12 1.01-2.41.26-.29.56-.36.75-.36h.54c.17 0 .4-.07.62.45.24.58.81 2 .88 2.15.07.15.11.34.02.54-.09.2-.13.34-.26.52-.13.18-.28.39-.4.52-.13.13-.27.27-.12.53.15.26.68 1.12 1.46 1.81 1 .89 1.84 1.16 2.1 1.3.26.13.41.11.56-.07.15-.18.65-.76.83-1.02.17-.26.35-.22.58-.13.24.09 1.51.71 1.77.84.26.13.43.2.5.31.07.11.07.67-.17 1.34z" />
      </svg>
      <span className="hidden text-sm font-semibold sm:inline">WhatsApp Support</span>
    </a>
  );
}

export default WhatsAppFloat;